"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgSkipForwardFilled(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("defs", null,
            React.createElement("style", null, '.skip-forward_filled_svg__cls-1{display:none}')),
        React.createElement("g", { id: "skip-forward_filled_svg__transparent_box" },
            React.createElement("path", { className: "skip-forward_filled_svg__cls-1", d: "M0 0h32v32H0z" }),
            React.createElement("path", { className: "skip-forward_filled_svg__cls-1", d: "M0 0h32v32H0z" })),
        React.createElement("path", { d: "M27 5h-2v9.87L5 4.34v23.32l20-10.53V27h2z", id: "skip-forward_filled_svg__FILLED" })));
}
exports.default = SvgSkipForwardFilled;
//# sourceMappingURL=SkipForwardFilled.js.map